const { createSlice } = require('@reduxjs/toolkit');
const { searchArticles } = require('reduxStore/actions/search');

const initialState = {
  userLoading: false,
  article: [],
  error: null,
};
const searchArticleSlice = createSlice({
  name: 'searchArticles',
  initialState,
  reducers: {
    setArticles: (state, action) => {
      state.article = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchArticles.fulfilled, (state, action) => {
        state.userLoading = false;
        state.article = action.payload;
      })
      .addCase(searchArticles.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(searchArticles.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});
export default searchArticleSlice.reducer;
export const { setArticles } = searchArticleSlice.actions;
